import React from "react";

export const MembershipConfirmedRight: React.FC<{}> = () => (
  <svg
    width="239px"
    height="492px"
    viewBox="0 0 239 492"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Group 4</title>
    <defs>
      <filter colorInterpolationFilters="auto" id="filter-1">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.811765 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter colorInterpolationFilters="auto" id="filter-2">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.811765 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter colorInterpolationFilters="auto" id="filter-3">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.811765 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter colorInterpolationFilters="auto" id="filter-4">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.811765 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter colorInterpolationFilters="auto" id="filter-5">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.811765 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter colorInterpolationFilters="auto" id="filter-6">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.811765 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter colorInterpolationFilters="auto" id="filter-7">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.811765 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter colorInterpolationFilters="auto" id="filter-8">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.811765 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter colorInterpolationFilters="auto" id="filter-9">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.811765 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter colorInterpolationFilters="auto" id="filter-10">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.811765 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter colorInterpolationFilters="auto" id="filter-11">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.811765 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter colorInterpolationFilters="auto" id="filter-12">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.811765 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter colorInterpolationFilters="auto" id="filter-13">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.811765 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter colorInterpolationFilters="auto" id="filter-14">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.811765 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter colorInterpolationFilters="auto" id="filter-15">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 0.811765 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
      <filter colorInterpolationFilters="auto" id="filter-16">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Confirmation" transform="translate(-1201.000000, -177.000000)">
        <g id="Group-4" transform="translate(1201.531984, 170.000000)">
          <rect
            id="Rectangle"
            fill="#1853A3"
            x="0"
            y="379"
            width="60"
            height="60"
          />
          <rect
            id="Rectangle"
            fill="#0F2B5A"
            opacity="0.5"
            x="60"
            y="319"
            width="60"
            height="60"
          />
          <rect
            id="Rectangle"
            fill="#7ADFF4"
            opacity="0.5"
            x="120"
            y="259"
            width="60"
            height="60"
          />
          <polygon
            id="Rectangle-Copy-9"
            fill="#0F2B5A"
            opacity="0.5"
            points="180 96 343 259 180 259"
          />
          <g
            id="Group-3"
            opacity="0.8"
            transform="translate(95.468016, 95.000000) scale(-1, 1) translate(-95.468016, -95.000000) translate(0.468016, 0.000000)"
          >
            <g
              id="3.-Icons/Plus"
              transform="translate(150.000000, 150.000000)"
              filter="url(#filter-1)"
            >
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="40" height="40" />
                <line
                  x1="8"
                  y1="20"
                  x2="32"
                  y2="20"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="20"
                  y1="8"
                  x2="20"
                  y2="32"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <g
              id="3.-Icons/Plus"
              transform="translate(100.000000, 150.000000)"
              filter="url(#filter-2)"
            >
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="40" height="40" />
                <line
                  x1="8"
                  y1="20"
                  x2="32"
                  y2="20"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="20"
                  y1="8"
                  x2="20"
                  y2="32"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <g
              id="3.-Icons/Plus"
              transform="translate(50.000000, 150.000000)"
              filter="url(#filter-3)"
            >
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="40" height="40" />
                <line
                  x1="8"
                  y1="20"
                  x2="32"
                  y2="20"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="20"
                  y1="8"
                  x2="20"
                  y2="32"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <g
              id="3.-Icons/Plus"
              transform="translate(0.000000, 150.000000)"
              filter="url(#filter-4)"
            >
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="40" height="40" />
                <line
                  x1="8"
                  y1="20"
                  x2="32"
                  y2="20"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="20"
                  y1="8"
                  x2="20"
                  y2="32"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <g
              id="3.-Icons/Plus"
              transform="translate(150.000000, 100.000000)"
              filter="url(#filter-5)"
            >
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="40" height="40" />
                <line
                  x1="8"
                  y1="20"
                  x2="32"
                  y2="20"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="20"
                  y1="8"
                  x2="20"
                  y2="32"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <g
              id="3.-Icons/Plus"
              transform="translate(50.000000, 100.000000)"
              filter="url(#filter-6)"
            >
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="40" height="40" />
                <line
                  x1="8"
                  y1="20"
                  x2="32"
                  y2="20"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="20"
                  y1="8"
                  x2="20"
                  y2="32"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <g
              id="3.-Icons/Plus"
              transform="translate(0.000000, 100.000000)"
              filter="url(#filter-7)"
            >
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="40" height="40" />
                <line
                  x1="8"
                  y1="20"
                  x2="32"
                  y2="20"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="20"
                  y1="8"
                  x2="20"
                  y2="32"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <g
              id="3.-Icons/Plus"
              transform="translate(150.000000, 50.000000)"
              filter="url(#filter-8)"
            >
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="40" height="40" />
                <line
                  x1="8"
                  y1="20"
                  x2="32"
                  y2="20"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="20"
                  y1="8"
                  x2="20"
                  y2="32"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <g
              id="3.-Icons/Plus"
              transform="translate(100.000000, 50.000000)"
              filter="url(#filter-9)"
            >
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="40" height="40" />
                <line
                  x1="8"
                  y1="20"
                  x2="32"
                  y2="20"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="20"
                  y1="8"
                  x2="20"
                  y2="32"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <g
              id="3.-Icons/Plus"
              transform="translate(50.000000, 50.000000)"
              filter="url(#filter-10)"
            >
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="40" height="40" />
                <line
                  x1="8"
                  y1="20"
                  x2="32"
                  y2="20"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="20"
                  y1="8"
                  x2="20"
                  y2="32"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <g
              id="3.-Icons/Plus"
              transform="translate(0.000000, 50.000000)"
              filter="url(#filter-11)"
            >
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="40" height="40" />
                <line
                  x1="8"
                  y1="20"
                  x2="32"
                  y2="20"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="20"
                  y1="8"
                  x2="20"
                  y2="32"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <g
              id="3.-Icons/Plus"
              transform="translate(150.000000, 0.000000)"
              filter="url(#filter-12)"
            >
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="40" height="40" />
                <line
                  x1="8"
                  y1="20"
                  x2="32"
                  y2="20"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="20"
                  y1="8"
                  x2="20"
                  y2="32"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <g
              id="3.-Icons/Plus"
              transform="translate(100.000000, 0.000000)"
              filter="url(#filter-13)"
            >
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="40" height="40" />
                <line
                  x1="8"
                  y1="20"
                  x2="32"
                  y2="20"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="20"
                  y1="8"
                  x2="20"
                  y2="32"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <g
              id="3.-Icons/Plus"
              transform="translate(50.000000, 0.000000)"
              filter="url(#filter-14)"
            >
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="40" height="40" />
                <line
                  x1="8"
                  y1="20"
                  x2="32"
                  y2="20"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="20"
                  y1="8"
                  x2="20"
                  y2="32"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <g id="3.-Icons/Plus" filter="url(#filter-15)">
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="40" height="40" />
                <line
                  x1="8"
                  y1="20"
                  x2="32"
                  y2="20"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="20"
                  y1="8"
                  x2="20"
                  y2="32"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <g
              id="3.-Icons/Plus"
              transform="translate(84.000000, 84.000000)"
              filter="url(#filter-16)"
            >
              <g id="Group">
                <rect id="Rectangle" x="0" y="0" width="72" height="72" />
                <line
                  x1="14.4"
                  y1="36"
                  x2="57.6"
                  y2="36"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="36"
                  y1="14.4"
                  x2="36"
                  y2="57.6"
                  id="Path"
                  stroke="#252525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
          </g>
          <path
            d="M239,319 L239,379 L299,379 L299,439 L239,439 L239,499 L179,499 L179,439 L119,439 L119,379 L179,379 L179,319 L239,319 Z"
            id="Combined-Shape"
            fill="#017CBD"
            opacity="0.6"
            transform="translate(209.000000, 409.000000) scale(-1, 1) translate(-209.000000, -409.000000) "
          />
        </g>
      </g>
    </g>
  </svg>
);

export default {};
